import * as EventConstants from 'constants/EventConstants';
import {declarativeWriteRESTObjsToApollo} from 'graphql-client/ApolloWrappers';
import {graphQLArrayToREST} from 'graphql-client/declarative-translations/external/translate';
import Syncer from 'graphql-client/sync/Syncer';
import AppDispatcher from 'lib/Dispatcher';
import SchemaFieldSelectorStore from 'registry/schema-field-selector/SchemaFieldSelectorStore';

import {SchemaFieldSelectorsForRegistryGraphQL} from '../../../../graphql-fragments/registry/__generated/SchemaFieldSelectorsForRegistryGraphQL';

type SelectorsByRegistryId = (typeof SchemaFieldSelectorStore)['selectorsByRegistryId'];

export default class SchemaFieldSelectorsForRegistrySyncer extends Syncer<
  SelectorsByRegistryId,
  SchemaFieldSelectorsForRegistryGraphQL
> {
  shouldSubscribeToRedux = false;
  stores = [SchemaFieldSelectorStore];

  readFromStore(): {current: SelectorsByRegistryId; equalityRef: unknown} {
    return {
      current: {...SchemaFieldSelectorStore.selectorsByRegistryId},
      equalityRef: SchemaFieldSelectorStore.selectorsByRegistryId,
    };
  }

  writeToApolloCache(inputs: SelectorsByRegistryId): void {
    const selectors = Object.entries(inputs).map(([id, schemaFieldSelectors]) => ({
      id,
      schemaFieldSelectors,
    }));
    declarativeWriteRESTObjsToApollo('SchemaFieldSelectorsForRegistry', selectors);
  }

  writeToStore(graphQLObjs: Array<SchemaFieldSelectorsForRegistryGraphQL>): void {
    const restSelectors = graphQLArrayToREST('SchemaFieldSelectorsForRegistry', graphQLObjs);
    // eslint-disable-next-line benchlint/no-spread-reduce
    const selectorsByRegistryId = restSelectors.reduce(
      (byId, {id, schemaFieldSelectors}) => ({
        ...byId,
        ...{[id]: schemaFieldSelectors},
      }),
      {}
    );
    AppDispatcher.dispatch({
      actionType: EventConstants.SCHEMA_FIELD_SELECTORS_FETCH_COMPLETED,
      selectorsByRegistryId,
    });
  }
}
